import { memo } from 'react'

import { withTolgee } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import type { IZaiHeroViewProps } from './zai-hero.types'

import './zai-hero.styles.scss'

const Component = withTolgee<IZaiHeroViewProps>(
  ({
    TitleComponent,
    brandData,
    FormComponent,
    PrePromptLinkComponent,
    ErrorComponent,
    SkeletonsComponent,
    prePromptList,
    formOnSubmit,
    t,
    isLoading,
    isError,
    refetch,
  }) => {
    return (
      <div className="zai-hero-container" data-testid="zai-hero-container">
        <TitleComponent brandData={brandData} />
        <div className="zai-hero-form-box">
          <FormComponent onSubmit={formOnSubmit} />
        </div>

        {isError && !isLoading && (
          <ErrorComponent
            errorMessage={t(TOLGEE_GLOBALS.errorTextHeader)}
            handleError={refetch}
            buttonText={t(TOLGEE_GLOBALS.retry)}
          />
        )}

        {!isError && !isLoading && Boolean(prePromptList.length) && (
          <ul className="zai-hero-pre-prompt-list">
            {prePromptList.map(prePrompt => (
              <li key={prePrompt.id} className="zai-hero-pre-prompt-list-item">
                <PrePromptLinkComponent url={prePrompt.url} variant={prePrompt.variant}>
                  {prePrompt.text}
                </PrePromptLinkComponent>
              </li>
            ))}
          </ul>
        )}

        {isLoading && <SkeletonsComponent />}
      </div>
    )
  }
)

export const ZaiHeroView = memo(Component)
